import { PackingCategoryDto } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class PackingCategoryResponseModel extends GlobalResponseObject{
    data?: PackingCategoryDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //PackingCategoryDto
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: PackingCategoryDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
